import {
  Box,
  Button,
  Flex,
  Table,
  TableContainer,
  Tbody,
  Th,
  Thead,
  Tr,
  useToast,
} from '@chakra-ui/react'
import Header from '../../../components/Header'
import { HeadingPages } from '../../../components/HeadingPages'
import InputFloating from '../../../components/InputFloating'
import { useForm } from 'react-hook-form'
import { z } from 'zod'
import { zodResolver } from '@hookform/resolvers/zod'
import { QueryErrorResetBoundary, useMutation } from 'react-query'
import { api } from '../../../services/api'
import { firstLetterUpperCaseAndRestLowerCase } from '../../../utils/capitalFirstLetter'
import React, { Suspense } from 'react'
import { Loader } from '../../../components/ComponentLoader/Loader'
import { ErrorBoundary } from 'react-error-boundary'
import { List } from './List'
import { ErrorLayoutBoundary } from './ErrorLayoutBoundary'

const schema = z.object({
  numeroPedido: z.string().min(1, 'Número do pedido é obrigatório'),
})

const AcompanhamentoRetificacao = React.lazy(() =>
  import('./AcompanhamentoRetificacao')
)

export function SolicitarRetificacao() {
  const {
    handleSubmit,
    register,
    formState: { errors },
    watch,
  } = useForm({
    resolver: zodResolver(schema),
  })

  const numeroPedido = watch('numeroPedido')

  const toast = useToast({
    position: 'top',
  })

  const { mutateAsync, data, isLoading } = useMutation({
    mutationFn: getInfoRetificacaoLayout,
    mutationKey: 'getInfoRetificacaoLayout',
    onError: (error) => {
      console.log(error)
      toast({
        title: 'Erro ao buscar informações de retificação de layout',
        status: 'error',
        duration: 9000,
        isClosable: true,
      })
    },
    onSuccess: (data) => {
      console.log(data)
    },
  })

  async function getInfoRetificacaoLayout(data) {
    const response = await api.get(
      `/site/v2/fluxo-layout/listar-info-retificacao/${data.numeroPedido}`
    )
    console.log(response.data)

    const dateFormatted = response.data.map((item) => {
      return {
        ...item,
        descricao_produto: firstLetterUpperCaseAndRestLowerCase(
          item.descricao_produto.length > 15
            ? item.descricao_produto.substring(0, 15) + '...'
            : item.descricao_produto
        ),
        cor: firstLetterUpperCaseAndRestLowerCase(item.cor),
        observacoes: firstLetterUpperCaseAndRestLowerCase(
          item.observacoes.length > 15
            ? item.observacoes.substring(0, 15) + '...'
            : item.observacoes
        ),
      }
    })

    return dateFormatted
  }

  async function handleGetInfoRetificacaoLayout(data) {
    try {
      await mutateAsync(data)
    } catch (error) {
      console.log(error)
    }
  }

  return (
    <>
      <HeadingPages name={'Retificação de OP'} />

      <Box
        maxW="500px"
        w="100%"
        mx="auto"
        display="flex"
        alignItems="start"
        gap="4"
        my="1.4rem"
        as="form"
        onSubmit={handleSubmit(handleGetInfoRetificacaoLayout)}
      >
        <InputFloating
          label="Número do pedido"
          {...register('numeroPedido')}
          error={errors.numeroPedido}
        />

        <Button colorScheme="blue" w="100px" type="submit" color="white">
          Pesquisar
        </Button>
      </Box>

      <Box w="100%" h="100vh">
        <Suspense fallback={<div>Carregando...</div>}>
          <AcompanhamentoRetificacao />
        </Suspense>

        <TableContainer
          textAlign="center"
          overflowY="auto"
          overflow="auto"
          height="calc(100vh - 25rem)"
        >
          <QueryErrorResetBoundary>
            {({ reset }) => (
              <ErrorBoundary
                onReset={reset}
                fallbackRender={({ resetErrorBoundary }) => (
                  <ErrorLayoutBoundary
                    resetErrorBoundary={resetErrorBoundary}
                  />
                )}
              >
                <Table
                  variant="striped"
                  colorScheme="gray"
                  fontSize=".9rem"
                  size={'sm'}
                >
                  <Thead
                    textAlign="center"
                    px="6rem"
                    position="sticky"
                    top="0"
                    zIndex="0"
                  >
                    <Tr bg="#378BBF" color="white" mx="6rem">
                      <Th color="white">Número nota</Th>
                      <Th color="white">Código produto</Th>
                      <Th color="white">Produto</Th>
                      <Th color="white">Cor</Th>
                      <Th color="white">Gravação</Th>
                      <Th color="white">Obs</Th>
                      <Th color="white">Link Layout</Th>
                      <Th color="white"></Th>
                    </Tr>
                  </Thead>

                  {isLoading && <Loader />}

                  <Tbody>
                    {!isLoading &&
                      data?.map((item, index) => (
                        <List
                          key={index}
                          item={item}
                          refetch={() =>
                            handleGetInfoRetificacaoLayout({ numeroPedido })
                          }
                        />
                      ))}
                  </Tbody>
                </Table>
              </ErrorBoundary>
            )}
          </QueryErrorResetBoundary>
        </TableContainer>
      </Box>
    </>
  )
}
